import { colors } from '../../colors';
var fiveCard = {
  textColor: colors.white,
  hoverColor: colors.dirtyBlue,
  bgColorPara: colors.black,
  bgColor: colors.white,
  cardBgColorB: colors.white,
  cardBgColorHoverB: colors.dirtyBlue,
  cardCTAColorB: colors.black,
  cardCTAColorHoverB: colors.white,
  textBgOpacity: '0.5',
  iconColor: colors.dirtyBlue,
  iconColorHover: colors.white,
  textBGWidthFull: true
};
export default fiveCard;